export const mapLayerIds = {
  GrowthModel: 0,
  Weather: 1,
  FieldAccessibility: 2,
  Crops: 3,
  Activities: 4,
  Devices: 5,
  Empty: 6
};
